"use client";

import { useEffect } from "react";
import { ErrorState } from "@/components/site/ErrorState";

/** Keeps the site header/footer when an inner page fails to render. */
export default function PagesError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <ErrorState
      code="خطا"
      title="مشکلی در نمایش این صفحه پیش آمد"
      lead="لطفاً دوباره تلاش کنید. اگر مشکل ادامه داشت، با کارشناسان سیمرغ تماس بگیرید."
      reference={error.digest}
      onRetry={reset}
    />
  );
}
